import { cn } from '../../lib/cn.ts';
import { Spinner } from '../spinner/spinner.tsx';

export interface LoadingLineProps {
  /** What is loading, in the words of the page: "Je team laden…". */
  label: string;
  className?: string;
}

/** A page or list that is still loading: the spinner beside one quiet line saying what. */
export function LoadingLine({ label, className }: LoadingLineProps) {
  return (
    <p
      data-slot='loading-line'
      className={cn('flex items-center gap-2 text-base text-ink-muted', className)}
    >
      <Spinner />
      {label}
    </p>
  );
}
